import Styles from './DesignContent.module.scss'
import cx from 'classnames'
import { DesignContentProps } from '../Types'
import { DesignPreview } from './DesignPreview'

export const DesignContent = ({ content, width, height, design_id }: DesignContentProps) => {
  const isLandscape = width > height

  return (
    <div className={Styles.designContent}>
      <div
        className={cx(Styles.designPreviewContainer, { [Styles.fullWidth]: content.length === 1 || isLandscape })}
        data-testid="design-preview"
      >
        {content.map((_, id) => (
          <DesignPreview key={id} option={id} content={content} width={width} height={height} designId={design_id} />
        ))}
      </div>
    </div>
  )
}
